//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<template>
  <div class='content-wrapper'>
    <p style="font-size:16px; padding-bottom:20px;">
      <b>Профиль</b>
      <router-link to="/"><i class="fas fa-times" style="font-size:20px; padding-right:3px; float:right;"></i></router-link>
    </p>

    <div v-if="activeUser == null" style="width:100%; float:left">
      Страница недоступна. Войдите в приложение
    </div>
    <div v-else>

    <div class="user-avatar" :style="{'background-image': 'url(' + serverData.imagesGetURL(activeUser.body.avatar) + ')'}">&nbsp;</div>

    <Form ref="userData" :model="userData" :rules="userDataRules" style="width:300px" class="passwordChanging">
        <p style="font-size:15px; padding-bottom:5px;">Имя</p>
        <Form-item prop="userName">
            <Input type="text" v-model="activeUserName" placeholder="Имя" icon="android-contact" size="large" class="input-left-icon" @on-blur='userNameOnBlur'></Input>
        </Form-item>

        <p style="font-size:15px; padding-bottom:5px; padding-top:10px;">Смена пароля</p>
        <Form-item prop="currentPassword" style=' margin-bottom: 20px;'>
            <Input type="password" v-model="userData.currentPassword" placeholder="Текущий пароль" icon="locked" size="large" class="input-left-icon password"></Input>
        </Form-item>
        <Form-item prop="newPassword" style='margin-bottom: 20px;'>
            <Input type="password" v-model="userData.newPassword" placeholder="Новый пароль" icon="locked" size="large" class="input-left-icon"></Input>
        </Form-item>
        <Form-item prop="newPasswordTwice" style=' margin-bottom: 25px;'>
            <Input type="password" v-model="userData.newPasswordTwice" placeholder="Новый пароль еще раз" icon="locked" size="large" class="input-left-icon"></Input>
        </Form-item>
        <Form-item style="margin-bottom:40px">
          <Button type="primary" size="large" class="login-form-button no-circle" long @click="submitOnClick()">Сменить пароль</Button>
        </Form-item>
    </Form>

    </div>

  </div>
</template>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<script>
import { mapGetters, mapMutations } from 'vuex'

import http from 'axios'

import serverData from '@/store/serverData'

export default {
  name: 'UserProfile',
  data () {
    return {
      userData: {
        currentPassword: '',
        newPassword: '',
        newPasswordTwice: ''
      },
      serverData: serverData,
      validateUserName: (rule, value, callback) => {
        if (this.activeUserName === '') { // BUG обход: здесь не работает value, приходится напрямую обращаться к this.activeUserName
          callback(new Error(this.i18n.login.validations.fieldCannotBeEmpty))
        }
        callback()
      },
      validateCurrentPassword: (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.i18n.login.validations.fieldCannotBeEmpty))
        }
        callback()
      },
      validateNewPassword: (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.i18n.login.validations.fieldCannotBeEmpty))
        } else {
          if (this.userData.newPasswordTwice !== '') {
            this.$refs.userData.validateField('newPasswordTwice')
          }
          callback()
        }
      },
      validateNewPasswordTwice: (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.i18n.login.validations.fieldCannotBeEmpty))
        } else if (value !== this.userData.newPassword) {
          callback(new Error(this.i18n.login.validations.passwordsNotEqual))
        } else {
          callback()
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'i18n',
      'appSettings',
      'activeUser'
    ]),
    activeUserName: {
      set: function (value) {
        let activeUser = window.cloneObject(this.activeUser)
        if (value !== '') {
          activeUser.name = value
          this.activeUserSet(activeUser)
        }
      },
      get: function () {
        return this.activeUser.name
      }
    },
    userDataRules: function () {
      return {
        userName: [
          // { required: true, message: this.i18n.login.validations.fieldCannotBeEmpty, trigger: 'blur' }
          { validator: this.validateUserName, trigger: 'blur' }
        ],
        currentPassword: [
          { validator: this.validateCurrentPassword, trigger: 'blur' }
        ],
        newPassword: [
          { validator: this.validateNewPassword, trigger: 'blur' }
        ],
        newPasswordTwice: [
          { validator: this.validateNewPasswordTwice, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    ...mapMutations([
      'appStateServerConnectedSet',
      'activeUserSet'
    ]),
    submitOnClick () {
      // this.$message(JSON.stringify(this.loginData, 2))
      this.$refs['userData'].validate((valid) => {
        if (valid) {
          var thisRef = this
          http.post(this.appSettings.server.userActiveChangePassword, {currentPassword: this.userData.currentPassword, newPassword: this.userData.newPassword})
          .then(function (response) {
            thisRef.$message.success('Пароль изменен')
          })
          .catch(function (error) {
            if (error.response === undefined) { // внутренняя ошибка в коде клиента
              thisRef.$message.error('Произошла ошибка: ' + error.message)
            } else {
              if (error.response === null) {
                thisRef.$message.error('Ошибка при попытке обратиться к серверу: Сервер не доступен')
                thisRef.appStateServerConnectedSet(false)
                thisRef.$router.push('/serverisnotavailable')
              } else {
                if (error.response.status !== 400) {
                  thisRef.$message.error('Ошибка при попытке обратиться к серверу: ' + error.response.status + ', ' + JSON.stringify(error.response.data))
                } else {
                  thisRef.$message.error(error.response.data)
                }
              }
            }
          })
        } else {
          this.$message.error('Поля заполненны не верно, попробуйте еще раз')
        }
      })
    },
    userNameOnBlur () {
      var thisRef = this
      http.post(this.appSettings.server.userActiveChangeName, {id: this.activeUser.id, name: this.activeUser.name})
      .then(function (response) {
        thisRef.$message.success('Имя пользователя изменено')
      })
      .catch(function (error) {
        if (error.response === undefined) { // внутренняя ошибка в коде клиента
          thisRef.$message.error('Произошла ошибка: ' + error.message)
        } else {
          if (error.response === null) {
            thisRef.$message.error('Ошибка при попытке обратиться к серверу: Сервер не доступен')
            thisRef.appStateServerConnectedSet(false)
            thisRef.$router.push('/serverisnotavailable')
          } else {
            if (error.response.status !== 400) {
              thisRef.$message.error('Ошибка при попытке обратиться к серверу: ' + error.response.status + ', ' + JSON.stringify(error.response.data))
            } else {
              thisRef.$message.error(error.response.data)
            }
          }
        }
      })
    }
  }
}
</script>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<style>
.passwordChanging .ivu-input {
  /*background-color:#D9E0E7;*/
}
</style>

<style scoped>
.content-wrapper{
  margin: 0px 0px 0px 0px;
  padding: 20px;
  /* overflow: hidden; */
  background: #fff; height: 100%; /* если цвет отличный от стандартной серой подложики для content или убираем серые margins, то чтобы серый прикрыть надо height=100% */
  font-family: "Open Sans", sans-serif;
  font-weight: 300;
  font-size: 15px;
}
a {
  color: #778087;
}
a:visited {
  color: #778087;
  text-decoration: none !important;
}
a:hover {
  color: #959595 !important;
  cursor: default;
  text-decoration: none !important;
}
.user-avatar {
  width: 80vw;
  height: 80vw;
  margin-bottom: 20px;
  background: #333;
  background-size: cover;
  background-position: center;
  border-radius: 40vw;
  border: solid 0px #fff;
  cursor: pointer;
  float: left;
}
@media screen and (min-width: 500px) {
  .user-avatar {
    width: 300px;
    height: 300px;
    border-radius: 150px;
  }
}

</style>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



// WEBPACK FOOTER //
// UserProfile.vue?784e14c5